export const REDO_EMAIL_DOMAINS = ["getredo.com", "redo.com"];

export const isRedoEmailAddress = (
  email: string | null | undefined,
): boolean => {
  const emailNormalized = email?.toLowerCase().trim();
  if (!emailNormalized) {
    return false;
  }

  const [localPart, domain, extraPart] = emailNormalized.split("@");
  if (!localPart || !domain || extraPart != null) {
    return false;
  }

  return REDO_EMAIL_DOMAINS.includes(domain);
};
